import { updatedFetch } from '../../utils/fetch/actionCreators';
import userManager from '../../utils/userManager';

export const authOnIdentity = (dispatch, history) => {
  const origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
  const url = origin + '/asset-manifest.json';
  dispatch(updatedFetch('GET', url))
    .then(asset_manifest => {
      //NOTE: in PROD asset_manifest['main.css'] è il path al css, in DEVELOPMENT è undefined
      if(process.env.REACT_APP_ENV === 'development') {
        userManager.settings.extraQueryParams = { appCssPath: origin + '/styleguidist/main.css' };
      }
      if(asset_manifest.files && asset_manifest.files['main.css']) {
        userManager.settings.extraQueryParams = { appCssPath: origin + asset_manifest.files['main.css'] };
      }
      const signinState = {};
      if(history.location.state) {
        signinState['data'] = { path: history.location.state };
      }
      userManager.signinRedirect(signinState);
    })
    .catch(() => {
      const signinState = {};
      if (history.location.state) {
        signinState['data'] = { path: history.location.state };
      }
      userManager.signinRedirect(signinState);
    });
};
